import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchMe } from "../../lib/api";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState(location.state?.user ? "ok" : "checking");

  useEffect(() => {
    if (location.state?.user) return;
    fetchMe()
      .then((u) => {
        if (u.is_admin) setState("ok");
        else { setState("denied"); navigate("/login", { state: { denied: true } }); }
      })
      .catch(() => { setState("no"); navigate("/login"); });
  }, [navigate, location.state]);

  if (state !== "ok") {
    return (
      <div className="min-h-screen bg-[#0a0a0a] grid place-items-center">
        <Loader2 className="animate-spin text-[#7CB518]" size={36} />
      </div>
    );
  }
  return children;
};
